/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Types of destructive operations requiring confirmation
 */
export enum DestructiveOperation {

    SuspendUser = 'suspend_user',

    DeleteUser = 'delete_user',

    SystemShutdown = 'system_shutdown',

    TradingHalt = 'trading_halt',

    TradingResume = 'trading_resume',

    EmergencyStop = 'emergency_stop',

    RiskOverride = 'risk_override',

    AdvancedTradingControl = 'advanced_trading_control'
}
